import type { CSSProperties } from 'react';

export function CustomerPortalLogo({ branding, onError }: {
  branding: { logoUrl?: string | null; storeName?: string; logoMaxWidth?: number | null; logoMaxWidthMobile?: number | null };
  onError: () => void;
}) {
  return <img src={branding.logoUrl || undefined} alt={branding.storeName || 'Logo'}
    className="mx-auto mb-10 h-auto w-auto max-h-20 max-w-[min(100%,var(--portal-logo-mobile))] sm:max-w-[min(100%,var(--portal-logo-desktop))] object-contain"
    style={{ '--portal-logo-mobile': `${branding.logoMaxWidthMobile ?? 140}px`, '--portal-logo-desktop': `${branding.logoMaxWidth ?? 200}px` } as CSSProperties}
    onError={onError} />;
}
